import { Link, useCanGoBack, useLocation, useRouter } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useLingui } from "@lingui/react/macro";
import { cameFromMenuItems } from "./menu-items-origin";

/**
 * Back from a menu item to the list. When the user arrived from the list this
 * steps back through history, so the list reappears in the same view with the
 * same search, page and filters. Anyone who landed here directly (a bookmark,
 * a pasted link) gets a plain link to the list instead.
 */
export function BackToMenuItemsLink() {
  const { t } = useLingui();
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const cameFromList = useLocation({ select: (location) => cameFromMenuItems(location.state) });

  return (
    <Link
      to="/menus"
      search={{ page: 1, pageSize: 50 }}
      onClick={(event) => {
        // Leave modified and non-primary clicks to the browser (new tab, etc.).
        const plain =
          event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
        if (plain && canGoBack && cameFromList) {
          event.preventDefault();
          router.history.back();
        }
      }}
      className="inline-flex w-fit items-center gap-1.5 text-sm text-(--color-text-secondary) transition-colors hover:text-(--color-text-primary)"
    >
      <ArrowLeft className="size-4" />
      {t`Back to Menu Items`}
    </Link>
  );
}
